import { useContext } from 'react'

import { OneOnOnesContext, type OneOnOnesContextValue } from '../context/OneOnOnesContext'

export const useOneOnOnesContext = (): OneOnOnesContextValue => {
  return useContext(OneOnOnesContext)
}
